module.exports = __webpack_public_path__ + "static/media/crosshair-dark.0fe5d8be.svg";